import React from "react";
import { useToastStore } from "../../stores/toastStore";

export const ToastContainer: React.FC = () => {
  const { toasts } = useToastStore();

  if (!toasts.length) return null;

  return (
    <div className="ob-toast-container">
      {toasts.map((toast) => (
        <div
          key={toast.id}
          className={[
            "ob-toast",
            toast.type === "success"
              ? "ob-toast-success"
              : toast.type === "error"
              ? "ob-toast-error"
              : ""
          ]
            .filter(Boolean)
            .join(" ")}
        >
          <div className="ob-toast-title">{toast.title}</div>
        </div>
      ))}
    </div>
  );
};

